import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Input from "../../../../componentes/input/input";
import Textarea from "../../../../componentes/input/textarea";
import Button from "../../../../componentes/button/button";
import { CustomDropdown } from "../../../../componentes/dropdown/CustomDropdown";
import AcaoButtons from "../../Shared/AcaoButtons";
import FuncionarioService from "../../../../services/resource/funcionarioService";

const funcionarioService = new FuncionarioService();

// Etapa "Reconhecimento do Condutor" — seleciona o condutor (CPF/CNH preenchidos automaticamente),
// informa valor descontado/parcelamento; o Termo de Responsabilidade é anexado na seção Anexos.
export default function EtapaMultaReconhecimento({ acoes = [], acaoEmExecucao, onExecutarAcao }) {
    const [condutorId, setCondutorId] = useState(null);
    const [cnh, setCnh] = useState(null);
    const [valorDescontado, setValorDescontado] = useState("");
    const [parcelamento, setParcelamento] = useState("");
    const [observacao, setObservacao] = useState("");
    const [condutores, setCondutores] = useState([]);

    useEffect(() => {
        funcionarioService.listar()
            .then(res => setCondutores(res.data || []))
            .catch(() => {
                toast.error("Erro ao carregar condutores.");
                setCondutores([]);
            });
    }, []);

    const condutorSelecionado = condutores.find(c => c.id === condutorId) || null;
    const podeEnviar = acoes.includes("ENVIAR");
    const outrasAcoes = acoes.filter(a => a !== "ENVIAR");

    function enviar() {
        if (!condutorId) {
            toast.error("Selecione o condutor responsável pela infração.");
            return;
        }
        onExecutarAcao("ENVIAR", {
            comentario: observacao || undefined,
            dados: {
                condutorId,
                valorDescontado: valorDescontado ? Number(valorDescontado) : undefined,
                parcelamento: parcelamento || undefined,
            },
        });
    }

    function executarOutraAcao(acao) {
        onExecutarAcao(acao, { comentario: observacao || undefined });
    }

    return (
        <div className="flex flex-col gap-4">
            <p className="text-sm text-muted-foreground">
                Identifique o condutor responsável pela infração e informe o valor descontado e o parcelamento, se aplicável.
            </p>

            <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-foreground/80">Condutor <span className="text-destructive">*</span></label>
                <CustomDropdown
                    value={condutorId}
                    onChange={e => setCondutorId(e.value)}
                    options={condutores}
                    optionValue="id"
                    optionLabel={x => `${x.nome} · ${x.cpf} · ${x.cargo}`}
                    placeholder="Selecione"
                    filter />
            </div>

            {condutorSelecionado && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <Input label="CPF" disabled value={condutorSelecionado.cpf || "-"} />
                    <Input label="CNH" value={cnh} onChange={e => setCnh(e.target.value)} />
                </div>
            )}

            <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                <div className="col-span-2">
                    <Input type="number" min="0" step="0.01" label="Valor descontado" value={valorDescontado} onChange={e => setValorDescontado(e.target.value)} />
                </div>
                <Input label="Parcelamento" value={parcelamento} onChange={e => setParcelamento(e.target.value)} />
            </div>

            <Textarea label="Observações" value={observacao} onChange={e => setObservacao(e.target.value)} rows={3} />

            <p className="text-xs text-muted-foreground">
                <i className="fa fa-info-circle mr-1" />
                Anexe o Termo de Responsabilidade na seção Anexos.
            </p>

            <div className="flex justify-end gap-2 flex-wrap">
                <AcaoButtons acoes={outrasAcoes} acaoEmExecucao={acaoEmExecucao} onAcao={executarOutraAcao} />
                {podeEnviar && (
                    <Button
                        variant="blue"
                        label="Enviar"
                        iconLeft="fa fa-paper-plane"
                        loading={acaoEmExecucao === "ENVIAR"}
                        onClick={enviar}
                    />
                )}
            </div>
        </div>
    );
}
